/* Honey & Paw - product quick view.
   Injects a "Quick view" button on each product card (appears on hover). Clicking it
   opens a modal with the product image, title, price, a short blurb, and add-to-cart,
   so shoppers can add without leaving the page. */
(function () {
  var HANDLE_RE = /\/products\/([^/?#]+)/;

  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(HANDLE_RE);
    return m ? m[1] : null;
  }

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function inject() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.hp-qv-btn')) return;
      if (card.classList.contains('collection-card-wrapper')) return;
      var handle = handleOf(card);
      if (!handle) return;
      var media = card.querySelector('.card__media') || card.querySelector('.card__inner');
      if (!media) return;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hp-qv-btn';
      b.textContent = 'Quick view';
      b.setAttribute('data-handle', handle);
      media.appendChild(b);
    });
  }

  var overlay, modal, lastFocus;
  function build() {
    if (modal) return;
    overlay = document.createElement('div');
    overlay.className = 'hp-qv-overlay';
    modal = document.createElement('div');
    modal.className = 'hp-qv-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Quick view');
    document.body.appendChild(overlay);
    document.body.appendChild(modal);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function close() {
    if (!modal) return;
    overlay.classList.remove('open');
    modal.classList.remove('open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function open(handle, trigger) {
    build();
    lastFocus = trigger || document.activeElement;
    modal.innerHTML = '<div class="hp-qv-loading">Loading...</div>';
    overlay.classList.add('open');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { modal.innerHTML = '<button class="hp-qv-close" aria-label="Close">&times;</button><div class="hp-qv-loading">Sorry, we could not load this product.</div>'; bindClose(); });
  }

  function bindClose() {
    var c = modal.querySelector('.hp-qv-close');
    if (c) c.addEventListener('click', close);
  }

  function render(p) {
    var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var desc = (p.description || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    if (desc.length > 200) desc = desc.slice(0, 200).trim() + '...';
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var canBuy = variant && variant.available;
    modal.innerHTML =
      '<button class="hp-qv-close" aria-label="Close">&times;</button>' +
      '<div class="hp-qv-grid">' +
        '<div class="hp-qv-media">' + (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">' : '') + '</div>' +
        '<div class="hp-qv-info">' +
          '<h3 class="hp-qv-title">' + p.title + '</h3>' +
          '<div class="hp-qv-price"><span class="now">' + money(p.price) + '</span>' + (sale ? ' <span class="was">' + money(p.compare_at_price) + '</span>' : '') + '</div>' +
          (desc ? '<p class="hp-qv-desc">' + desc + '</p>' : '') +
          '<button class="button button--primary hp-qv-add" data-vid="' + (variant ? variant.id : '') + '"' + (canBuy ? '' : ' disabled') + '>' + (canBuy ? 'Add to cart' : 'Sold out') + '</button>' +
          '<a class="hp-qv-full" href="' + p.url + '">View full details &rarr;</a>' +
        '</div>' +
      '</div>';
    bindClose();
    var add = modal.querySelector('.hp-qv-add');
    if (add && canBuy) add.addEventListener('click', function () { addToCart(variant.id, add); });
    setTimeout(function () { modal.querySelector('.hp-qv-close').focus(); }, 40);
  }

  function addToCart(vid, btn) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: Number(vid), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
        if (res.status) return;
        close();
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(res);
          cart.classList.remove('is-empty');
          if (typeof cart.open === 'function') cart.open();
        } else {
          window.location = (window.routes && routes.cart_url) ? routes.cart_url : '/cart';
        }
      })
      .catch(function () { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    inject();
    document.addEventListener('shopify:section:load', inject);
    document.addEventListener('click', function (e) {
      var qv = e.target.closest('.hp-qv-btn');
      if (!qv) return;
      e.preventDefault();
      e.stopPropagation();
      open(qv.getAttribute('data-handle'), qv);
    });
  });
})();
